<template>
    <div>
        <text-input
            name="name"
            label="Namn"
            :required="true"
            :autofocus="true"
        />
        <div v-for="(type, key) in types" class="mb-xs">
            <radio-input
                v-model="selectedType"
                name="type"
                :value="key"
                :required="true"
            >
                {{ type }}
            </radio-input>
        </div>
        <div v-if="selectedAddresses.length > 0" class="mt-lg">
            Antal adresser: {{ selectedAddresses.length }}
            <div v-for="address in selectedAddresses">
                <input
                    type="hidden"
                    name="addresses[]"
                    :value="address.id"
                >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            types: {
                type: Object,
                required: true,
            },
            selectedAddresses: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                },
            },
        },

        data() {
            return {
                selectedType: '',
            };
        },
    };
</script>
